import React from "react";
import Box from "@mui/material/Box";
import Link from "@mui/material/Link";
import WarningIcon from "@mui/icons-material/Warning";
import useMediaQuery from "@mui/material/useMediaQuery";

export default function CustomErrorBoundaryComponent() {
  // The mediaQuery needs to be hardcoded instead of using theme because theme is initialized lower in the Navigation component.
  // If an error hits before the theme is initialized, this line will throw an error.
  const minWidthSm = useMediaQuery("(min-width:600px)", {
    noSsr: true,
  });

  const openBeacon = () => {
    window.Beacon("navigate", "/ask/message");
    window.Beacon("open");
  };

  return (
    <Box
      width="100%"
      height="100%"
      pl={2}
      pr={2}
      display="flex"
      flexDirection={minWidthSm ? "row" : "column"}
      alignItems="center"
      justifyContent="center"
    >
      <WarningIcon
        color="error"
        sx={{ mr: minWidthSm ? 4 : 0, fontSize: 80 }}
      />
      <Box maxWidth={620}>
        <Box
          fontSize="28px"
          fontWeight="bold"
          textAlign={minWidthSm ? "left" : "center"}
        >
          Oops!
        </Box>
        <Box textAlign={minWidthSm ? "left" : "center"}>
          Something went wrong. Please try refreshing the page, or{" "}
          <Link href="/">click here</Link> to go home. If this error persists,{" "}
          <Link component="button" onClick={openBeacon}>
            click here
          </Link>{" "}
          to contact support.
        </Box>
      </Box>
    </Box>
  );
}
